var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.virtualTour)?_c('div',{staticClass:"home"},[_c('Home'),_c('About'),_c('Team'),_c('Jobs'),_c('Testimonials'),_c('Contact')],1):_c('div',[_c('TourVirtual')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }